// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Edit = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Edit = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Edit = _exports.Edit = function Edit(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.4583 12.5V15C16.4583 17.015 15.3483 18.125 13.3333 18.125H5C2.985 18.125 1.875 17.015 1.875 15V6.66667C1.875 4.65167 2.985 3.54167 5 3.54167H7.5C7.845 3.54167 8.125 3.82167 8.125 4.16667C8.125 4.51167 7.845 4.79167 7.5 4.79167H5C3.68583 4.79167 3.125 5.3525 3.125 6.66667V15C3.125 16.3142 3.68583 16.875 5 16.875H13.3333C14.6475 16.875 15.2083 16.3142 15.2083 15V12.5C15.2083 12.155 15.4883 11.875 15.8333 11.875C16.1783 11.875 16.4583 12.155 16.4583 12.5ZM18.125 5.04667C18.1242 5.53583 17.9333 5.995 17.5867 6.34L10.1175 13.7758C9.99999 13.8925 9.84167 13.9583 9.67667 13.9583H6.66667C6.32167 13.9583 6.04167 13.6783 6.04167 13.3333V10.3242C6.04167 10.1592 6.10666 9.99999 6.22416 9.88332L13.66 2.41333C14.0042 2.06666 14.4641 1.87583 14.9533 1.875C14.9541 1.875 14.955 1.875 14.9559 1.875C15.4442 1.875 15.9034 2.065 16.2492 2.41084L17.59 3.75168C17.935 4.09751 18.1258 4.5575 18.125 5.04667ZM14.6808 7.46918L12.5308 5.31916L7.29167 10.5825V12.7092H9.41834L14.6808 7.46918ZM16.875 5.04499C16.875 4.88999 16.815 4.74418 16.7058 4.63501L15.365 3.29417C15.2558 3.185 15.11 3.125 14.9559 3.125H14.955C14.8 3.125 14.655 3.18584 14.5458 3.29501L13.4133 4.4325L15.5675 6.58666L16.705 5.45418C16.8142 5.34584 16.8742 5.19999 16.875 5.04499Z",
      fill: "#212B36"
    }));
  };
});
